import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class StartService {

    _profileUrl = "/profileData";
    _userStatusUrl = "/loginData/userStatus";
    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    emailValidated() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._userStatusUrl, options)
            .toPromise()
            .then(res => {
                console.log(JSON.parse(res.text()).active);
                if (JSON.parse(res.text()).code != -1) {
                    return JSON.parse(res.text()).active != 2;
                }
                else {
                    return false;
                }
            });
    }

    userProperties() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._profileUrl, options)
            .toPromise()
            .then(res => { return JSON.parse(res.text()).row[0] })
            .catch(this.handleError);
    }

    acceptTerms() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + '/start/termsValidation', options)
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return JSON.parse(res.text()).active != 2;
                }
                else {
                    return false;
                }
            });
    }

    createTransaction(accountType: number, method: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/createTransaction', this.serializeObj({ "accountType": accountType, "method": method }), {
            headers: authHeader
        })
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text());
                }
                else {
                    return JSON.parse(res.text());
                }
            });
    }

    updateTransaction(id: number, method: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/updateTransaction', this.serializeObj({ "method": method, "id": id }), {
            headers: authHeader
        })
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text());
                }
                else {
                    return JSON.parse(res.text());
                }
            });
    }

    resendEmail() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + '/emailData/resendEmail', options)
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return JSON.parse(res.text()).active != 2;
                }
                else {
                    return false;
                }
            });
    }

    existsEmail(email: string) {
        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
            .then(res => {
                console.log(res);
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, this.handleError);
    }

    enterDashboard() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        console.log("validateAccount");
        return this.http.get(this.serverURL + '/validateAccount', options).toPromise()
            .then(res => {
                console.log(res);
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, this.handleError);
    }

    postInformation(values: any) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        console.log(this.serializeObj(values));
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/usersInfoData', this.serializeObj(values), {
            headers: authHeader
        })
            .map((res: any) => {
                let data = res.json();
                return data.code;
            });
    }

    registerFree() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/registerFree', {}, {
            headers: authHeader
        })
            .map((res: any) => {
                let data = res.json();
                return data.code;
            });
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Promise.reject(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any = [];

        for (var property in obj)
            if (encodeURIComponent(obj[property]) != "")
                result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/start.service.ts
 **/